export default ({ height = 24, width = 24, customClass = '' }) => (
  <svg width={width} height={height} class={customClass} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M7 14L12 9L17 14H7Z' fill='black' />
  </svg>
)
